export default __webpack_public_path__ + "static/media/alphabet-yellow-w.3db9cac5.png";